/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Fr2_EyebrowInputs */

const en_funnel_sq_fr2_eyebrow = /** @type {(inputs: Funnel_Sq_Fr2_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academic-paper aware`)
};

const es_funnel_sq_fr2_eyebrow = /** @type {(inputs: Funnel_Sq_Fr2_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entiende los artículos académicos`)
};

/**
* | output |
* | --- |
* | "Academic-paper aware" |
*
* @param {Funnel_Sq_Fr2_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_fr2_eyebrow = /** @type {((inputs?: Funnel_Sq_Fr2_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Fr2_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_fr2_eyebrow(inputs)
	return en_funnel_sq_fr2_eyebrow(inputs)
});